const platforms = [
  {
    id: 'threads',
    label: 'Threads',
    icon: 'T',
    color: '#000000',
    textColor: '#fff',
  },
  {
    id: 'x',
    label: 'X',
    icon: 'X',
    color: '#000000',
    textColor: '#fff',
  },
  {
    id: 'instagram',
    label: 'Instagram',
    icon: 'I',
    color: '#E1306C',
    textColor: '#fff',
  },
  {
    id: 'youtube',
    label: 'Youtube',
    icon: 'Y',
    color: '#FF0099',
    textColor: '#fff',
  },
  {
    id: 'tiktok',
    label: 'TikTok',
    icon: 'T',
    color: '#000000',
    textColor: '#fff',
  },
  // {
  //   id: 'instiz',
  //   label: 'Instiz',
  //   icon: 'I',
  //   color: '#03C75A',
  //   textColor: '#fff',
  //   author: '인스티즈',
  //   site: 'instiz.net',
  // },
  {
    id: 'dcinside',
    label: 'DC',
    icon: 'D',
    color: '#29367C',
    textColor: '#fff',
    account: 'dcinside',
  },
  // {
  //   id: 'fmkorea',
  //   label: 'FM코리아',
  //   icon: 'F',
  //   color: '#3B5998',
  //   textColor: '#fff',
  //   login: 'fmkorea',
  // },
  {
    id: 'theqoo',
    label: 'TheQoo',
    icon: 'T',
    color: '#FF9900',
    textColor: '#fff',
    site: 'theqoo.net',
    author: '더쿠',
  },
  {
    id: 'ppomppu',
    label: '뽐뿌',
    icon: 'P',
    color: '#FF6B00',
    textColor: '#fff',
  },
  // {
  //   id: 'ruliweb',
  //   label: '루리웹',
  //   icon: 'R',
  //   color: '#1185D1',
  //   textColor: '#fff',
  //   site: 'ruliweb.com',
  //   author: '루리웹',
  // },
  {
    id: 'naverkin',
    label: 'N.Kin',
    icon: 'N',
    color: '#03C75A',
    textColor: '#fff',
    account: 'naver',
  },
  {
    id: 'navercafe',
    label: 'N.Cafe',
    icon: 'N',
    color: '#03C75A',
    textColor: '#fff',
    account: 'naver',
  },
  {
    id: 'naverblog',
    label: 'N.Blog',
    icon: 'N',
    color: '#03C75A',
    textColor: '#fff',
    account: 'naver',
  },
  {
    id: 'reddit',
    label: 'Reddit',
    icon: 'R',
    color: '#FF4500',
    textColor: '#fff',
    account: 'reddit',
  },
  {
    id: 'lips',
    label: 'LIPS',
    icon: 'L',
    color: '#fa8c91',
    textColor: '#fff',
  },
  {
    id: 'atcosme',
    label: '@cosme',
    icon: 'A',
    color: '#2fb6aa',
    textColor: '#fff',
  },
];

export default platforms;